import OrderIcon from '@mui/icons-material/AttachMoney';
import UserList from './UserList';
export default {
    list: UserList,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
